import { ModalContainer, styled, Button as BaseButton } from '@innowise-group/mui-kit';

export const Modal = styled(ModalContainer)`
  width: 45rem;
`;

export const ModalTitle = styled.div`
  ${({ theme }) => theme.fonts.primary[90]}
  color: ${({ theme }) => theme.palette.general.lightGrey[70]};
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2.25rem 2.5rem 0.5rem 2.5rem;
`;

export const Description = styled.div`
  padding: 0 2rem;
  ${({ theme }) => theme.fonts.primary[20]};
  font-weight: 500;
  color: ${({ theme }) => theme.palette.general.darkGrey[80]};
  line-height: 22px;
`;

export const Footer = styled.div`
  display: flex;
  padding: 1.5rem 2.5rem 2.5rem 2.5rem;
`;

export const ModalActions = styled(Footer)`
  gap: 0.5rem;
  padding: 0;
  width: 100%;

  & > button {
    flex: 1;
  }
`;

export const Button = styled(BaseButton)`
  &.MuiButtonBase-root.MuiButton-root {
    border-radius: 8px;
    height: 3.125rem;
    transition: 0.2s;
    ${({ theme }) => theme.fonts.primary[30]};

    &.MuiButton-outlined {
      color: ${({ theme }) => theme.palette.general.darkGrey[70]};
      border-color: ${({ theme }) => theme.palette.general.darkGrey[60]};

      &:hover {
        color: ${({ theme }) => theme.palette.general.darkGrey[80]};
        border-color: ${({ theme }) => theme.palette.general.darkGrey[80]};
      }
    }
    &.MuiButton-contained {
      background-color: ${({ theme }) => theme.palette.general.darkGrey[80]};

      &:hover {
        background-color: ${({ theme }) => theme.palette.general.darkGrey[60]};
      }
    }
  }
`;
